export const downloadFile = (url) => {
  const a = document.createElement('a')
  a.href = url
  a.download = '' // ファイル名が URL に含まれていれば不要だが、任意で指定可
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
